"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IpisPlusIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var icons_react_1 = require("@tabler/icons-react");
var withIconSize_1 = __importDefault(require("../../hocs/withIconSize"));
var client_utils_1 = require("../../utils/client-utils");
var IpisPlusIcon_ = function (props) {
    var className = props.className, rest = __rest(props, ["className"]);
    if (props.variant === "circle") {
        return ((0, jsx_runtime_1.jsx)(icons_react_1.IconPlus, __assign({}, rest, { className: (0, client_utils_1.classNames)(props.className, "rounded-full") })));
    }
    return (0, jsx_runtime_1.jsx)(icons_react_1.IconPlus, __assign({}, rest, { className: props.className }));
};
exports.IpisPlusIcon = (0, withIconSize_1.default)(IpisPlusIcon_);
